import type { FunctionComponent } from 'react'
import React from 'react'
import { Button } from '@arvoreeducacao/bonsai-ds'
import {
  StyledModal,
  Description,
  ModalFooter,
  Title
} from './ModalSubscriptionPaid.styles'

import { hotjarEvent } from 'utils/ui-trackers/hotjar'

import { COMBO_URL } from 'config/vars'

interface ModalProps {
  showModal: boolean
}

const ModalSubscriptionPaid: FunctionComponent<ModalProps> = ({
  showModal
}) => {
  const subscriptionPaidModalTitle =
    'Estudante já possui assinatura válida para o ano letivo vigente.'
  const subscriptionPaidModalText =
    'Acesse com o seu login de uso pessoal. Caso não se lembre, recupere-o agora mesmo.'

  const goToAccessRecovery = () => {
    window.open(`${COMBO_URL}/login/recuperar-acesso`, '_self')
    hotjarEvent('recovery-access')
  }

  const goToLogin = () => {
    window.open(`${COMBO_URL}/login`, '_self')
  }

  const buttonLogin = (
    <Button
      style={{ margin: 14 }}
      onClick={goToLogin}
      primary
      large
      data-testid="login-button"
    >
      Fazer Login
    </Button>
  )

  const buttonRecover = (
    <Button
      style={{ margin: 14 }}
      onClick={goToAccessRecovery}
      ghost
      large
      data-testid="access-recovery-button"
    >
      Recuperar acesso
    </Button>
  )

  return (
    <StyledModal show={showModal} canCloseByXBtn={false}>
      <Title>{subscriptionPaidModalTitle}</Title>
      <Description>{subscriptionPaidModalText}</Description>
      <ModalFooter>
        {buttonRecover}
        {buttonLogin}
      </ModalFooter>
    </StyledModal>
  )
}

export default ModalSubscriptionPaid
